import type { FaireProductEntity } from "../../entity_types/product";

export const p_4qtrrj2gog: FaireProductEntity = {
  token: "p_4qtrrj2gog",
  type: "product",
  name: "TART CHERRY SLEEP SUPPORT | 16 Oz",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/072bdd642ade43b649e25c93d4da251deab7f187a20f613013c6fe96b27eae86.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fa94092bf56a224111194681dd6de1f6fec2c46f97152601fdc5d1fc546465f4.jpeg",
    "https://cdn.faire.com/fastly/20af88fab97d361a4bd70733f345d90394b6686abdb947b831bb552b9b4b82ed.png",
    "https://cdn.faire.com/fastly/9f13511e443e8741c29ebc470d8b8fa164414f2664808943b2a024ddc16cce60.jpeg",
  ],
  priceDollars: 20.3,
  description:
    "This customer favorite contains tart cherries, which are not only rich in melatonin but also help the body to naturally produce melatonin. The added Chamomile and Valerian Root enhance the calming and relaxing effects, helping you to get better, deeper rest!\n\nOur Tart Cherry Sleep Support can also be helpful with supporting weight loss, reducing inflammation, supporting heart health, aiding with muscle recovery, and supporting male and female fertility! The ingredients in this syrup have also been proven to reduce and combat feelings of anxiety and depression.\n\nOur honey free version is a great option for those under the age of one and for those who are diabetic or insulin resistant.\n\nTO USE: Shake well. Adults take 1–2 tablespoons daily before bed. Children (ages 1+) take 1–2 teaspoons daily before bed. After opening, refrigerate and use within 2–3 months. (Children under the age of 1 should not ingest honey.)\n\n*See website for ingredients: wholesale.rowecasaorganics.com*",
  tags: [],
  msrpDollars: 29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:11.465Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
